module.exports = __webpack_public_path__ + "static/media/task.13114aca.svg";